import { useForm } from 'react-hook-form';
import { FormProvider, SelectTag, TextField } from '../../../../../components';
import {
  Container,
  Grid,
  Paper,
  Stack,
  Typography,
  TextField as MuiTextField,
  IconButton,
  Dialog
} from '@mui/material';
import { useCallback, useEffect, useRef, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { dropdownFetch, formatDate, getKeyPathValue, request, toast } from '../../../../../utils';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../components';
import { PAYMENT_MODE} from '../../../../../constants/dropdown';
import CloseIcon from '@mui/icons-material/Close';
import { Table } from '../../../../../components';


const initialExpenseEntryObj = {
  data: [],
  loading: false
};

const EXPENSE_ENTRY_TABLE_COLUMNS = [
  { header: 'Voucher No.', accessor: 'voucher_no' },
  { header: 'Date', accessor: (row)=> formatDate(row?.date)},
  { header: 'Account', accessor: (row)=>row?.account?.ledger_name},
  { header: 'Expense Head', accessor: (row)=> row?.expense_head?.expense_head },
  { header: 'Amount', accessor: (row)=> row?.rec_amt },
  { header: 'Status',
    accessor: (row)=> row?.status,
   sx:{textTransform:'uppercase'}
  },
];


export const ExpenseEntry = () => {
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const pathParts = pathname.split('/');
  const organisation = pathParts[1];
  const [loading, setLoading] = useState(false);
  const [expenseEntryDataObj, setExpenseEntryDataObj] = useState(initialExpenseEntryObj);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const [OpenQueryDialogs, setOpenQueryDialogs] = useState(false);
  const [input, setInput] = useState('');
  const [accountLedger, setAccountLedger] = useState([]);
  const [expenseHead,setExpenseHead] = useState([])
  const user = JSON.parse(localStorage.getItem('user'));

  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        rec_amt: Yup.string().required(' ')
      })
    ),
    defaultValues: {
      date: new Date().toISOString().split('T')[0],
      time: new Date().toLocaleTimeString('en-US', { hour12: false }).slice(0, 5)
    },
    mode: 'all'
  });
  const { handleSubmit, watch, reset, setValue } = methods;

  useEffect(() => {
    if (selectedRecord) {
      const keyValuePair = getKeyPathValue('', ['_id', 'status', 'createdAt']);
      keyValuePair.forEach(({ key, value }) => setValue(key, value));
      const formattedDate = selectedRecord?.date ? new Date(selectedRecord.date).toISOString().split('T')[0] : '';
      setValue('date',formattedDate);
      setValue('voucher_no',selectedRecord?.voucher_no);
      setValue('expense_head',selectedRecord?.expense_head?._id)
      setValue('account',selectedRecord?.account?._id)
      setValue('pay_mode',selectedRecord?.pay_mode)
      setValue('rec_amt',selectedRecord?.rec_amt)
      setValue('remarks',selectedRecord?.remarks)
    } else {
      reset();
    }
  }, [selectedRecord]);

  const formSubmit = async (formValues) => {
    setLoading(true);
    let editFlag = false;
    if (selectedRecord && currentAction === 'edit') {
      editFlag = true;
    }
    const response = await request(editFlag ? '/expense-entry-update' : '/expense-entry-create', {
      method: editFlag ? 'PUT' : 'POST',
      params: editFlag ? selectedRecord._id : null,
      body: {
        ...formValues,
        createdBy: user.name,
        updatedBy: editFlag ? user.name : '',
        organisation
      }
    });
    if (response?.success) {
      toast(`Successfully ${editFlag ? 'Updated' : 'Created'} Expense Entry`, { variant: 'success' });
      setSelectedRecord(response.data);
      setCurrentAction();
    } else {
      toast(`Failed to ${editFlag ? 'update' : 'create'} Expense Entry`, { variant: 'error' });
    }
    setLoading(false);
  };

  const handleQueryWindow = async () => {
    setOpenQueryDialogs(true);
    setExpenseEntryDataObj({ loading: true });
    const response = await request('/expense-entry-list', { method: 'GET' });
    if (response.success) {
      setExpenseEntryDataObj({ loading: false, data: response.data });
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setExpenseEntryDataObj({ loading: false });
    }
    setLoading(false);
  };

  useEffect(() => {
    handleSearch();
  }, [input]);

  const handleSearch = async () => {
    setExpenseEntryDataObj({ loading: true });
    const query = {};
    const lowercasedInput = input.toLowerCase().trim();
    if (lowercasedInput) {
      query.name = lowercasedInput;
    }
    const response = await request('/expense-entry-list', { method: 'GET', query: query });
    if (response.success) {
      setExpenseEntryDataObj({ loading: false, data: response.data });
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setExpenseEntryDataObj({ loading: false });
    }
    setLoading(false);
  };

  const handleChange = (e) => {
    setInput(e.target.value);
  };

  const handleCancelRecord = async () => {
    setLoading(true);
    const response = await request('/expense-entry-cancel', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully cancel Expense Entry ', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to cancel Expense Entry ', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleDeleteRecord = async () => {
    setLoading(true);
    const response = await request('/expense-entry-delete', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully deleted Expense Entry', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to delete Expense Entry', { variant: 'error' });
    }
    setLoading(false);
  };

  const getAccountLedgerData = useCallback(async () => {
    const data = await dropdownFetch('account-ledger');
    setAccountLedger(data);
  }, []);

  
  const getExpenseHeadData = useCallback(async () => {
    const data = await dropdownFetch('expense-head-master');
    setExpenseHead(data);
  }, []);


  useEffect(() => {
    getAccountLedgerData();
    getExpenseHeadData()
  }, [getAccountLedgerData,getExpenseHeadData]);




  return (
    <>
      <Paper sx={{ p: 0, flex: 1, borderRadius: 0, boxShadow: 'none', width: '100%', height: 'auto' }} >
        <Container
          sx={{ mt: 2, p: 0.2, border: '1px solid', borderColor: 'grey.300', borderRadius: 1, width: '100%',
            maxWidth: 'none', minWidth: '100%', boxSizing: 'border-box' }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                pb: 0.5,
                mb: 3,
                borderBottom: '1px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                Expense Entry
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn
                  id={`${lastPathSegment}Write`}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction)}
                  onClick={() => {
                    setSelectedRecord();
                    setCurrentAction('new');
                    reset();
                  }}
                >
                  New
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Update`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                  onClick={() => setCurrentAction('edit')}
                >
                  Edit
                </CustomButtonn>
                <CustomButtonn
                  id={'Submit'}
                  type="submit"
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                >
                  Save
                </CustomButtonn>
                <CustomButtonn
                  id={'Cancel'}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction) || loading}
                  onClick={() => {
                    setCurrentAction();
                    handleCancelRecord();
                  }}
                >
                  Cancel
                </CustomButtonn>
                <CustomButtonn
                  id={`isSuperAdmin`}
                  variant="contained"
                  disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                  onClick={handleDeleteRecord}
                >
                  Delete
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Read`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction)}
                  onClick={handleQueryWindow}
                >
                  Query
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Print`}
                  variant="contained"
                  onClick={() => window.open(`/print${pathname}?refId=${selectedRecord._id}`, '_blank')}
                  disabled={!selectedRecord || currentAction}
                >
                  Print
                </CustomButtonn>
                <CustomButtonn
                  id={'Exit'}
                  variant="contained"
                  onClick={() => {
                    setCurrentAction('');
                  }}
                >
                  Exit
                </CustomButtonn>
              </Stack>
            </Stack>
            <Grid container spacing={2} >
              <Grid item xs={11} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Stack
                  sx={{
                    border: '1px solid #d3d3d3',
                    padding: '5px',
                    borderRadius: '5px',
                    justifyContent: 'space-between',
                    padding: '15px',
                    gap: 5
                  }}
                  spacing={0.5}
                  direction="row"
                >
                  <Grid item xs={6} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                    <Stack spacing={0.5} direction="row" alignItems="center">
                      <Typography sx={{ flex: 0.35, fontWeight: 700, fontSize: '1rem', fontSize: '1.4rem' }}>
                        Voucher No.
                      </Typography>
                      <TextField 
                      sx={{ flex: 0.8 }}
                       name="voucher_no"
                      disabled
                      />
                    </Stack>
                    <Stack spacing={0.5} direction="row" alignItems="center">
                      <Typography sx={{ flex: 0.35, fontWeight: 700, fontSize: '1rem', fontSize: '1.4rem' }}>
                        Expense Head
                      </Typography>
                      <SelectTag
                        disabled={!['new', 'edit'].includes(currentAction)}
                        formControlSX={{ flex: 0.8 }}
                        name="expense_head"
                        placeholder=""
                        menus={expenseHead.map((data)=> ({...data,name:data.expense_head}))}
                      />
                    </Stack>
                    <Stack spacing={0.5} direction="row" alignItems="center">
                      <Typography sx={{ flex: 0.35, fontWeight: 700, fontSize: '1rem', fontSize: '1.4rem' }}>
                        Pay Mode
                      </Typography>
                      <SelectTag 
                      formControlSX={{ flex: 0.8 }}
                      name="pay_mode"
                      disabled={!['new', 'edit'].includes(currentAction)}
                      menus={PAYMENT_MODE}
                      
                      />
                    </Stack>
                    <Stack spacing={0.5} direction="row" alignItems="center">
                      <Typography sx={{ flex: 0.35, fontWeight: 700, fontSize: '1rem', fontSize: '1.4rem' }}>
                        Amount
                      </Typography>
                      <TextField
                        inputProps={{ style: { fontSize: '1.5rem', padding: '5px' } }}
                        disabled={!['new', 'edit'].includes(currentAction)}
                        sx={{ flex: 0.8 }}
                        name="rec_amt"
                        placeholder="Enter Amount"
                      />
                    </Stack>
                  </Grid>
                  <Grid item xs={6} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                      <Typography sx={{ flex: 0.35, fontWeight: 700, fontSize: '1rem', fontSize: '1.4rem' }}>
                        Date
                      </Typography>
                      <TextField
                        disabled={!['new', 'edit'].includes(currentAction)}
                        sx={{ flex: 0.8 }} name="date" type="date"
                      />
                    </Stack>
                    <Stack spacing={0.5} direction="row" alignItems="center">
                      <Typography sx={{ flex: 0.35, fontWeight: 700, fontSize: '1rem', fontSize: '1.4rem' }}>
                        Account
                      </Typography>
                      <SelectTag
                        formControlSX={{ flex: 0.8 }}
                        disabled={!['new', 'edit'].includes(currentAction)}
                        name="account"
                        placeholder=""
                        menus={accountLedger.map((data) => ({
                          ...data,
                          name: data.ledger_name
                        }))}
                      />
                    </Stack>
                    <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.35, fontWeight: 700, fontSize: '1rem', fontSize: '1.4rem' }}>
                    Remarks
                  </Typography>
                  <TextField
                    inputProps={{ style: { fontSize: '1.5rem', padding: '5px' } }}
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.8 }}
                    name="remarks"
                    placeholder="Remarks"
                  />
                </Stack>
                  </Grid>
                </Stack>
              </Grid>
            </Grid>
          </FormProvider>
        </Container>
      </Paper>

         <Dialog
        open={OpenQueryDialogs}
        onClose={() => setOpenQueryDialogs(false)}
        PaperProps={{ sx: { width: '70%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
           Expense Entry Query Window
          </Typography>
          <IconButton onClick={() => setOpenQueryDialogs(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
          <MuiTextField
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '14px',
                fontWeight: 700
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 10px'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem'
              }
            }}
            label="Search By Voucher No."
            variant="outlined"
            value={input}
            onChange={handleChange}
          />
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={EXPENSE_ENTRY_TABLE_COLUMNS}
          data={expenseEntryDataObj.data || []}
          onRowClick={(row) => {
            setSelectedRecord(row);
            setOpenQueryDialogs(false);
          }}
          loading={expenseEntryDataObj.loading}
        />
      </Dialog>
    </>
  );
};
